export const getIncomeUrl = "erp-recruitment/income";

/** User đã có Authenticator — GET verify OTP → `{ section }` */
export const getVerifyOtpUrl = (otp: string) =>
  `erp-recruitment/income/${encodeURIComponent(otp)}`;

/**
 * User mới — sau khi quét QR, POST OTP hoàn tất cài đặt → `{ section }`
 * (đổi path nếu backend khác)
 */
export const postSetupVerifyOtpUrl = "erp-recruitment/income/setup/verify";

export const getListNotifyIncomeUrl = (screen) =>
  `erp-recruitment/notify/income/${screen}`;

export const getDetailNotifyIncomeUrl = (screen, id) =>
  `erp-recruitment/notify/income/${screen}/${id}`;
